<template>
  <footer class="footer">
    <div class="copyright">
      <span
        >Copyright&nbsp;©&nbsp;{{ year }}&nbsp;{{
          tenantInfo.brandName
        }}&nbsp;ALL RIGHTS RESERVED</span
      >
      <span
        >&nbsp;ICP备案号：<a href="http://beian.miit.gov.cn/">{{
          tenantInfo.footer.beian
        }}</a></span
      >
    </div>
    <div class="browser">
      <a-popover>
        <template slot="content">
          <a-icon type="chrome"/><a target="_blank" href="https://www.google.cn/chrome/">下载谷歌浏览器</a>
        </template>
        <a-icon type="chrome" theme="filled" style="color: green; margin-right:5px"/><span>请使用谷歌浏览器</span>
      </a-popover>
    </div>
  </footer>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
export default {
  name: "Footer",
  data() {
    return {
      year: new Date().getFullYear(),
      tenantInfo: {},
    };
  },
  created() {
    this.tenantInfo = Vue.ls.get(TENANT_CONFIG);
  },
};
</script>
<style lang="less" scoped>
footer {
  position: absolute;
  bottom: 0;
  background: transparent;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 15px;
  text-align: center;

  .copyright,
  .copyright a {
    color: #242425;
    opacity: 0.8;
    font-size: 16px;
  }
  .browser {
      margin-top:20px;
  }
}
</style>